import React from 'react';
import PropTypes from 'prop-types';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

const LoadingOverlay = ({ open, message }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <CircularProgress color="inherit" />
      {message && (
        <Typography variant="h6" align="center">
          {message}
        </Typography>
      )}
    </Backdrop>
  );
};

LoadingOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  message: PropTypes.string,
};

export default LoadingOverlay;
